/**
 * Apex Cardiometabolic Center tenant configuration (PROD-568, Profile A).
 *
 * Source: master Pre-flight Decisions Tenant Profile Names + Multi-Clinic
 * Divergence Mechanism. Apex is the regular metabolic clinic; the source
 * library is the conventional ACC/AHA + ESC + ADA + AACE stack and the
 * priority weighting is operational efficiency (throughput first).
 *
 * Source library tags use the year-versioned form per HC3 citation
 * discipline (PATHWAY-PRD TENANT-4 amended in the 2026-05-05 fixer
 * round). The Phase 2 RAG retriever uses these tags to disambiguate
 * guideline versions before the relevance threshold pass.
 *
 * Per ADR-PROTO-002 the display string is a synthetic placeholder; the
 * `DEMO TENANT - SYNTHETIC CONFIGURATION` footer carries the warning.
 */
import type { TenantConfig } from './types';

export const apexCardiometabolic: TenantConfig = {
  id: 'apex-cardiometabolic',
  displayName: 'Apex Cardiometabolic Center',
  defaultProtocol: 'cardiometabolic-pathway',
  sourceLibraryTags: ['ACC2018', 'ESC2019', 'ADA2024', 'AACE2017'],
  clinicalPriorityWeighting: 'operational-efficiency',
  nbaFrequency: 'moderate',
};
